import React from "react";
import theme from "../Theme";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";
import useSession from "src/Hooks/useSession";
import { useMediaQuery } from "@mui/material";
import { COLLECTION_LABEL_PROPERTY_ID } from "src/utils";

function Provider({ children }) {
  const {
    sessionDetails: { restaurant },
  } = useSession();
  const isMobile = useMediaQuery("@media (max-width:899.95px)");
  const base_colour =
    restaurant?.property_id === COLLECTION_LABEL_PROPERTY_ID
      ? "#003E14"
      : restaurant?.theme?.base_colour?.trim();
  const responsiveTheme = responsiveFontSizes(
    theme({
      base_colour,
      isMobile: isMobile,
    })
  );
  return (
    <ThemeProvider theme={responsiveTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default Provider;
